import './scripts/modernizr';
import animations from './scripts/animations';
import backgroundGradients from './scripts/backgroundGradients';
import header from './scripts/header';
import footer from './scripts/footer';
import replaceIcons from './scripts/icons';
import wordpressUI from './scripts/wordpressUI';
import wordpressBlocks from './scripts/wordpressBlocks';
import annualReportNav from './scripts/annualReportNav';
import waveMaskRepaint from './scripts/waveMaskRepaint';

import accordions from './template-parts/blocks/accordions/accordions';
import articles from './template-parts/blocks/articles/articles';
import capabilities from './template-parts/blocks/capabilities/capabilities';
import cards from './template-parts/blocks/cards/cards';
import fiftyFifty from './template-parts/blocks/fifty-fifty/fifty-fifty';
import interactiveDNA from './template-parts/blocks/interactive-dna/interactive-dna';
import interactiveMap from './template-parts/blocks/google-map/google-map';
import hero from './template-parts/blocks/hero/hero';
import hoverList from './template-parts/blocks/hover-list/hover-list';
import greenhouseAPI from './template-parts/blocks/job-listings-greenhouse-api/job-listings-greenhouse-api';
import searchableList from './template-parts/blocks/searchable-list/searchable-list';
import stackedCards from './template-parts/blocks/stacked-cards/stacked-cards';
import statistics from './template-parts/blocks/statistics/statistics';
import tabs from './template-parts/blocks/tabs/tabs';
import tiles from './template-parts/blocks/tiles/tiles';
import presenterCarousel from './template-parts/blocks/presenter-carousel/presenter-carousel';
import eventTabs from './template-parts/blocks/event-tabs/event-tabs';

export const docReady: (fn: () => void) => void = (fn) => {
  if (
    document.readyState === 'complete' ||
    document.readyState === 'interactive'
  ) {
    setTimeout(fn, 1);
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
};

if (window.location.href.includes('post.php')) {
  setTimeout(() => {
    wordpressUI();
  }, 100);
} else {
  docReady(() => {
    [
      animations,
      backgroundGradients,
      header,
      footer,
      replaceIcons,
      wordpressBlocks,
      accordions,
      articles,
      capabilities,
      cards,
      fiftyFifty,
      interactiveDNA,
      interactiveMap,
      hero,
      hoverList,
      greenhouseAPI,
      searchableList,
      stackedCards,
      statistics,
      tabs,
      tiles,
      presenterCarousel,
      eventTabs,
      annualReportNav,
      waveMaskRepaint,
    ].forEach((fn) => {
      try {
        fn();
      } catch (e) {
        console.error(e);
      }
    });
  });
}
